import { useCardPaymentsParameterStore } from './useCardPaymentsParameterStore'

export const CardPaymentsStatsigStore = {
  useCardPaymentsParameterStore,
}
